import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StepLabel from '@material-ui/core/StepLabel';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { iconGray, white } from '../../../theme';
import { removeBrTag } from '../../../helpers/ui';

import useStyles from '../useStyles';
import styles from '../../Wizard/Step/Step.module.scss';

const VerticalLabel = (props) => {
  const { step, index, handleClick, isTouched, isCurrent } = props;
  const { t } = useTranslation();

  const classes = useStyles();
  const stepIconClass = useMemo(() => {
    if (isCurrent) {
      return classes.stepIconCurrent;
    }
    return isTouched ? classes.stepIconTouched : classes.stepIconLocked;
  }, [
    classes.stepIconCurrent,
    classes.stepIconLocked,
    classes.stepIconTouched,
    isCurrent,
    isTouched,
  ]);

  return (
    <StepLabel
      style={{ cursor: 'pointer' }}
      onClick={() => handleClick(step, index)}
      StepIconComponent={() => (
        <div className={classes.stepIconContainer}>
          <div className={styles.stepIconWrapper}>
            <div
              onClick={() => handleClick(step, index)}
              className={cn(styles.stepIcon, stepIconClass)}
            >
              {step.icon ? (
                React.cloneElement(step.icon, {
                  color: isTouched ? white : iconGray,
                })
              ) : (
                <Icon name={step.iconName} className={styles.namedIcon} />
              )}
            </div>
          </div>
        </div>
      )}
    >
      <span className={cn(classes.stepLabelText, { [classes.stepLabelTextTouched]: isTouched })}>
        {/* Here is used this method to remove <br> tag, on mobile device it's redundant */}
        {removeBrTag(t(step.label))}
      </span>
    </StepLabel>
  );
};

VerticalLabel.propTypes = {
  step: PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    icon: PropTypes.shape({}),
    label: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  isTouched: PropTypes.bool.isRequired,
  isCurrent: PropTypes.bool.isRequired,
};

export default VerticalLabel;
